/* eslint-disable no-cond-assign */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */

/* eslint-disable import/no-extraneous-dependencies */


import { Fancybox, Panzoom, Carousel} from "@fancyapps/ui";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm";
import { Toolbar } from "@fancyapps/ui/dist/panzoom/panzoom.toolbar.esm";



import flatpickr from "flatpickr";
import MonthSelectPlugin from "flatpickr/dist/plugins/monthSelect/index";
import  "flatpickr/dist/l10n/ru";


/* eslint-enable import/no-extraneous-dependencies */


import './lib/calcNew'; 

import './lib/banners'; // code for banners rotating

import './lib/fileupload'; 

import './lib/dragndrop';

import './lib/avitothumb'; // code for files uploadinfg jQuery using

import './lib/program';
import "./lib/actions";

// import "./program24";

import  wishListUpdate from './lib/wishlist';

// eslint-disable-next-line import/named
import { formsInit } from './lib/forms';

import { Modal } from './lib/modal';

import './lib/scrollTop';

Fancybox.bind("[data-fancybox]", {
  // Your custom options
});

const mCarousel = document.querySelector('.mainCarousel');
const carousels = document.querySelectorAll('.carousel');
if(mCarousel&&carousels){

  const mainCarousel = new Carousel(mCarousel, {
    Autoplay: {
      timeout: 5000,
      showProgress: false
    },
    // infinite: false,
    transition: "classic",
    Dots: false,
    Navigation: false,
    touch : false,
    // friction : 0.94,
  }, { Autoplay });

  Object.values(carousels).forEach(carousel => {
    const myCarousel = new Carousel(carousel, {
      Autoplay: false,
      Sync: {
        target: mainCarousel,
      },

      transition: "classic",
      Dots: false,
      Navigation: false,
      // friction : 0.94,
      touch : false,
      
    }, { Autoplay });
  });
}else if(!mCarousel&&carousels){
  Object.values(carousels).forEach(carousel => {
    const myCarousel = new Carousel(carousel, {
      Autoplay: {
        timeout: 2000,
      },
      transition: "classic",
      slidesPerPage: 1,
      Dots: false,
      Navigation: false,
      friction : 0.94,
      // touch : false,
      
    });
  }, { Autoplay });
}

const carouselWithNav = document.querySelectorAll('.carousel_with_nav');

if(carouselWithNav){
  Object.values(carouselWithNav).forEach(carousel => {

    const myCarouselWithNav = new Carousel(carousel, {
      Autoplay: {
        timeout: 2000,
      },
      // slidesPerPage: 1,
      // center: true,
      Dots: false,
      // Navigation: false,
      friction : 0.94,
      // touch : false,
      
    });
  });
}

const carouselWithNavOneSlide = document.querySelectorAll('.carousel_with_nav_oneslide');

if(carouselWithNavOneSlide){
  Object.values(carouselWithNavOneSlide).forEach(carousel => {

    const myCarouselWithNavOneSlide = new Carousel(carousel, {
      Autoplay: {
        timeout: 2000,
      },
      slidesPerPage: 1,
      center: true,
      Dots: false,
      // Navigation: false,
      friction : 0.94,
      // touch : false,
      
    });
  });
}


document.addEventListener('DOMContentLoaded', function () {
  
  formsInit();

  const preloader = document.querySelector(".preloader");
  if (preloader){
    preloader.classList.remove('active');
  }

}); 

const dateinputs = document.querySelectorAll('.dateinput');

for (let i = 0; i < dateinputs.length; i++) {
    const fp = flatpickr(dateinputs[i], {});  // flatpickr
}


// const tl = new TimelineMax();	
// tl.staggerFromTo('.stag', 0.5, { y: 20, opacity: 0 }, { y: 0, opacity: 1}, 0.2);

// gsap.registerPlugin(ScrollTrigger);

// gsap.utils.toArray('.column_gsap').forEach(section => {
//   const elems = section.querySelectorAll('p');
//   // Set starting params for sections
//   gsap.set(elems, {
//     x: 50,
//     opacity: 0,
//     duration: 1,
//     overwrite: 'auto',
//   });

//   ScrollTrigger.create({
//     trigger: section,
//     start: 'top 60%',
//   //  end: 'bottom top',
//     // markers: true,
//     onEnter: () => gsap.to(elems, {
//       x: 0,
//       opacity: 1,
//       stagger: 0.2,
//     }),

//   });
// })


// gsap.utils.toArray('.counts').forEach(section => {
//   const elems = section.querySelectorAll('.count');
//   // console.log(elems);
//   // Set starting params for sections
//   gsap.set(elems, {
//     y: 50,
//     opacity: 0,
//     duration: 1,
//     overwrite: 'auto',
//   });

//   ScrollTrigger.create({
//     trigger: section,
//     start: 'top 80%',
//     end: 'bottom 10%',
//     // markers: true,
//     onEnter: () => gsap.to(elems, {
//       y: 0,
//       opacity: 1,
//       stagger: 0.2,
//     }),

//   });
// })

const controls = document.querySelector(".controls");





// / footer menu colllapses

const fcts = document.querySelectorAll(".footer_column_title");

for (let i = 0; i < fcts.length; i++) {
  fcts[i].addEventListener("click", function footerMenu(event) {
    event.preventDefault();
    this.parentElement.classList.toggle('collapsed');
  });
}


const burger = document.querySelector('.burger');
const mobmenu = document.querySelector('.mobmenu');


if (burger) {
  burger.addEventListener('click', function burg (event) {
    event.preventDefault();
    burger.classList.toggle('clicked');
    mobmenu.classList.toggle('is-active');

  });
}
// ////////////////////////////////////////////////////////////////////////////
// ///////////////*  xhr requests  *///////////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////// 
let csrf = '';
if (document.querySelector('meta[name="csrf-token"]')){
  csrf = document.querySelector('meta[name="csrf-token"]').content;
}

const xhrurl = '/assets/components/nonfiction/webconnector.php';

let params; let datax; let xhr; let obj; 
let isForChildren;
let publishingDate;
let maxc = 0;
let bookPDF;
let zoneID;
let dateID;

document.addEventListener('click', (e) => {
  // console.log(e.target);

  if (e.target.dataset.action && (e.target.dataset.action !== '')) {

    switch (e.target.dataset.action) {

      case 'get-program-item':

        e.preventDefault();

        if (e.target.dataset.zoneId){
          zoneID = e.target.dataset.zoneId;
          dateID = document.querySelectorAll('.program_header_date li a.active')[0].dataset.dateId;
        }

        if (e.target.dataset.dateId) {
          dateID = e.target.dataset.dateId;
          zoneID = document.querySelectorAll('.program_header_zones li a.active')[0].dataset.zoneId;
        }

        params = {
          action: e.target.dataset.action,
          dateID, zoneID,     
        };

        datax = new URLSearchParams(params).toString();

        xhr = new XMLHttpRequest();
        xhr.open("POST", document.location.href, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

        document.querySelectorAll('.program_header_zones li a').forEach(f => { f.classList.remove('active') });
        document.querySelector(`.program_header_zones li a[data-zone-id="${zoneID}"]`).classList.add('loadingZone');

        xhr.send(datax);
        xhr.onload = function () {
          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
            document.querySelector('.program_header_zones li a.loadingZone').classList.remove('loadingZone');

          } else {

            obj = JSON.parse(xhr.response);

            document.querySelectorAll('.program_header_date li a').forEach(f => { f.classList.remove('active') });

            document.querySelector(`.program_header_date li a[data-date-id="${obj.dateID}"]`).classList.add('active');
            document.querySelector(`.program_header_zones li a[data-zone-id="${obj.zoneID}"]`).classList.add('active');
            document.querySelector('.program_table').innerHTML = obj.output;

            window.history.pushState({}, '', `${document.location.origin}${document.location.pathname}?dateID=${obj.dateID}&zoneID=${obj.zoneID}`);
            document.querySelector('.program_header_zones li a.loadingZone').classList.remove('loadingZone');
            wishListUpdate();
          }
        }

        break;


      case 'get-book-item':

        e.preventDefault();
        
        if (e.target.dataset.isChildren) {
          isForChildren = e.target.dataset.isChildren;
          dateID = document.querySelectorAll('.books_header_date li a.active')[0].dataset.dateId;
        }

        if (e.target.dataset.dateId) {
          dateID = e.target.dataset.dateId;
          isForChildren = document.querySelectorAll('.books_categories li a.active')[0].dataset.isChildren;
        }

        params = {
          action: e.target.dataset.action,
          dateID, isForChildren
        };

        datax = new URLSearchParams(params).toString();

        xhr = new XMLHttpRequest();
        xhr.open("POST", document.location.href, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

        document.querySelectorAll('.books_categories li a').forEach(f => { f.classList.remove('active') });

        xhr.send(datax);
        xhr.onload = function () {
          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
          } else {

            obj = JSON.parse(xhr.response);

            document.querySelectorAll('.books_header_date li a').forEach(f => { f.classList.remove('active') });

            document.querySelector(`.books_header_date li a[data-date-id="${obj.dateID}"]`).classList.add('active');

            document.querySelector(`.books_categories li a[data-is-children="${obj.isForChildren}"]`).classList.add('active');
            
            document.querySelector('.book_table').innerHTML = obj.output;
            window.history.pushState({}, '', `${document.location.origin}${document.location.pathname}?dateID=${obj.dateID}&isForChildren=${obj.isForChildren}`);

          }
        }
        break;


      case 'removeParent':
        e.preventDefault();
        e.target.parentNode.remove();
        break;


      case 'send-subscribe-form':
        
        if (e.target.closest('form').checkValidity()) {
          e.preventDefault();
          const ser = new URLSearchParams(Array.from(new FormData(e.target.closest('form')))).toString();

          params = {
            // url: xhrurl,
            action: e.target.dataset.action,
            sendSubscribeForm: ser,
            cultureKey: document.documentElement.lang,

          };

          datax = new URLSearchParams(params).toString();

          xhr = new XMLHttpRequest();
          xhr.open("POST", xhrurl, true);
          xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
          xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

          e.target.classList.add('disabled', 'loading');

          xhr.send(datax);
          xhr.onload = function () {
            if (xhr.status !== 200) {
              console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
              e.target.classList.remove('disabled', 'loading');
            } else {

              obj = JSON.parse(xhr.response);

              if (obj.success) {
                const modal = new Modal();
                modal.data(obj.object.modaltitle, obj.object.modaldata, obj.object.buttons, obj.object.images);
                modal.active();

                e.target.closest('form').reset();
                e.target.classList.remove('disabled', 'loading');
              } else{
                e.target.classList.remove('disabled', 'loading');
              }
            }
          }
        }
        
        break;

      case 'send-form':
      case 'send-form-top-list':
      case 'send-form-hudozhnik':
      case 'send-wishlist':

        if (e.target.closest('form').checkValidity()) {
          e.preventDefault();

          const ser = new URLSearchParams(Array.from(new FormData(e.target.closest('form')))).toString();

          params = {
            // url: xhrurl,
            action: e.target.dataset.action,
            sendForm: ser,
            cultureKey: document.documentElement.lang,
          };

          datax = new URLSearchParams(params).toString();

          xhr = new XMLHttpRequest();
          xhr.open("POST", xhrurl, true);
          xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
          xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

          e.target.classList.add('disabled', 'loading');

          xhr.send(datax);
          xhr.onload = function () {
            if (xhr.status !== 200) {
              console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
              e.target.classList.remove('disabled', 'loading');
            } else {

              obj = JSON.parse(xhr.response);

              if (obj.success) {
                e.target.classList.remove('disabled', 'loading');
                const modal = new Modal();
                modal.data(obj.object.modaltitle, obj.object.modaldata, obj.object.buttons, obj.object.images);
                modal.active();

                e.target.closest('form').reset();
                
                e.target.closest('form').querySelectorAll('.form_relative').forEach(f => { f.classList.remove('is-active') });

                // formsInit();


                const fnP = document.querySelectorAll('.fileNamePhisic');
                if (fnP){
                  fnP.forEach(f => {
                    f.parentNode.remove();
                  });
                }

                const formBooks = document.querySelectorAll('.form_book_n');
                if (formBooks){
                  formBooks.forEach(function(f,index){
                    if (index !== 0){
                      f.remove();
                    }
                  });

                  document.querySelector("[data-action='cloneFormFieldsRemove']").classList.add('disabled');
                  document.querySelector("[data-action='cloneFormFields']").classList.remove('disabled');

                }



                

              } else {
                e.target.classList.remove('disabled', 'loading');
              }
            }

          }

        }
          
        break;



      case 'cloneFormFieldsRemove':
        maxc = document.querySelector('.maxcount').dataset.maxcount;
        // console.log(maxc);
        e.preventDefault();

        if (document.querySelectorAll('.form_book_n').length === 2) {
          document.querySelectorAll('.form_book_n')[document.querySelectorAll('.form_book_n').length - 1].remove();
          e.target.classList.add('disabled');

        } else if (document.querySelectorAll('.form_book_n').length > 2) {
          document.querySelectorAll('.form_book_n')[document.querySelectorAll('.form_book_n').length - 1].remove();
        }

        if (document.querySelectorAll('.form_book_n').length <= (maxc - 1)) {
          document.querySelector("[data-action='cloneFormFields']").classList.remove('disabled');
        }


        break;  

      case 'cloneFormFields':
        
        e.preventDefault();

        maxc = document.querySelector('.maxcount').dataset.maxcount;

        if (document.querySelectorAll('.form_book_n').length > maxc) {
          break;
        }

        if (document.querySelectorAll('input[name^="publishing_date"]').length > 0){
          publishingDate = 1
        }

        if (document.querySelectorAll('input[name^="is_for_children"]').length > 0) {  
          isForChildren = 1
        }
        if (document.querySelectorAll('input[name^="bookPDF"]').length > 0) {  
          bookPDF = 1
        }

        params = {
          // url: xhrurl,
          action: 'cloneFormFields',
          bookPDF,
          publishingDate,
          isForChildren,
          length: document.querySelectorAll('.form_book_n').length,
        };

        datax = new URLSearchParams(params).toString();

        xhr = new XMLHttpRequest();
        xhr.open("POST", xhrurl, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        
        e.target.classList.add('disabled', 'loading');
        
        xhr.send(datax);

        xhr.onload = function () {

          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
            e.target.classList.remove('disabled', 'loading');
          } else {
            obj = JSON.parse(xhr.response);
            if (obj.success) {

              e.target.classList.remove('disabled', 'loading');

              const newC = document.createElement('div');
              newC.innerHTML = obj.object.fields;

              document.querySelectorAll('.form_book_n')[document.querySelectorAll('.form_book_n').length - 1].after(newC.querySelector('.form_book_n'));

              if (document.querySelectorAll('.form_book_n').length > 1) {
                document.querySelector("[data-action='cloneFormFieldsRemove']").classList.remove('disabled');
              }
              
              // formsInit();
              
              flatpickr(".pickMonth", {
                allowInput: true,
                enableTime: false,
                "locale": "ru",
                dateFormat: "Y-m",
                plugins: [
                  new MonthSelectPlugin({
                    //     shorthand: true, // defaults to false
                    dateFormat: "Y-m", // defaults to "F Y"
                    //     altFormat: "F Y", // defaults to "F Y"
                  })
                ],

              });
              
              if (document.querySelectorAll('.form_book_n').length > (maxc - 1)) {
                document.querySelector("[data-action='cloneFormFields']").classList.add('disabled')
              }
              
            } else {
              e.target.classList.remove('disabled', 'loading');

            }
          }

        }

        break;  

      case 'toplistVote':
  
        e.preventDefault();
        params = {
          // url: xhrurl,
          action: 'toplistVote',
          bookid: e.target.dataset.bookid,
          vote: e.target.dataset.vote,

        };

        datax = new URLSearchParams(params).toString();

        xhr = new XMLHttpRequest();
        xhr.open("POST", xhrurl, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        e.target.classList.add('disabled', 'loading');
        xhr.send(datax);

        xhr.onload = function () {

          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
            e.target.classList.remove('disabled', 'loading');
          } else {
            obj = JSON.parse(xhr.response);
            if (obj.success) {

              e.target.classList.remove('disabled', 'loading');

              if (obj.object.text) {
                
                const datari = document.querySelector(`[data-rating-id="${e.target.dataset.bookid}"]`);
                datari.classList.remove('red', 'green', 'gray');
                datari.classList.add(obj.object.colorClass);
                datari.innerHTML = obj.object.text;
                e.target.classList.remove('disabled', 'loading');

              }
              if (obj.object.book_rating_my_details) {
                document.querySelector(`.top_list_my_details[data-rating-id="${e.target.dataset.bookid}"]`).innerHTML = `Моя оценка: ${obj.object.book_rating_my_details}`;
              }

            } else {
              e.target.classList.remove('disabled', 'loading');

            }
          }

        }



        break;


      case 'ratingToModal':
        e.preventDefault();
        
        params = {
          // url: xhrurl,
          action: 'ratingToModal',
          bookid: e.target.dataset.bookid,
        };

        datax = new URLSearchParams(params).toString();

        xhr = new XMLHttpRequest();
        xhr.open("POST", xhrurl, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        e.target.classList.add('disabled', 'loading');
        xhr.send(datax);
        xhr.onload = function () {

          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
            e.target.classList.remove('disabled', 'loading');
          } else {
            obj = JSON.parse(xhr.response);
            if (obj.success) {

              e.target.classList.remove('disabled', 'loading');
              const modal = new Modal();
              modal.data(obj.object.modaltitle, obj.object.modaldata, obj.object.buttons, obj.object.images);
              modal.active();

            } else {
              e.target.classList.remove('disabled', 'loading');

            }
          }

        }

        break;


      case 'update':

        if (e.target.closest('form').checkValidity()) {
          
          e.preventDefault();
          // const ser = new URLSearchParams(Array.fromEntries(new FormData(e.target.closest('form')))).toString();
          const ser = new URLSearchParams(Array.from(new FormData(e.target.closest('form')))).toString();

          params = {
            // url: xhrurl,
            action: 'update',
            pageID: e.target.dataset.pageid,
            sendForm: ser

          };

          datax = new URLSearchParams(params).toString();

          xhr = new XMLHttpRequest();
          xhr.open("POST", xhrurl, true);
          xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
          xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
          e.target.classList.add('disabled', 'loading');
          xhr.send(datax);
          xhr.onload = function () {

            if (xhr.status !== 200) {
              console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
              e.target.classList.remove('disabled', 'loading');
            } else {
              obj = JSON.parse(xhr.response);
              if (obj.success) {


                e.target.classList.remove('disabled', 'loading');
                const modal = new Modal();
                modal.data(obj.object.modaltitle, obj.object.modaldata, obj.object.buttons, obj.object.images);
                modal.active();

              } else {
                e.target.classList.remove('disabled', 'loading');

              }
            }

          }
        }

        break;


      case 'newbookvote':

        e.preventDefault();
        params = {
          // url: xhrurl,
          action: 'newbookvote',
          bookid: e.target.dataset.bookid,
          vote: e.target.dataset.vote,

        };

        datax = new URLSearchParams(params).toString();

        xhr = new XMLHttpRequest();
        xhr.open("POST", xhrurl, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('X-CSRF-TOKEN', csrf);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        e.target.classList.add('disabled', 'loading');
        xhr.send(datax);

        xhr.onload = function () {

          if (xhr.status !== 200) {
            console.log(`Error ${xhr.status}: ${xhr.statusText}`); // eslint-disable-line no-console
            e.target.classList.remove('disabled', 'loading');
          } else {
            obj = JSON.parse(xhr.response);
            if (obj.success){
              const datari = document.querySelector(`[data-rating-id="${e.target.dataset.bookid}"]`);              
              datari.classList.remove('red','green');
              datari.classList.add(obj.object.colorClass);
              e.target.classList.remove('disabled','loading');

            }else{
              e.target.classList.remove('disabled','loading');

            }
          }

        }

        break;


      default:
        console.log(`Sorry, we are out of ${e.target.dataset.action}.`); // eslint-disable-line no-console
    }
  }

})

// ////////////////////////////////////////////////////////////////////////////
// ///////////////*  eof xhr requests  *///////////////////////////////////////
// //////////////////////////////////////////////////////////////////////////// 

// /////////////////////////////////////////////
// scroll section
// /////////////////////////////////////////////


document.querySelectorAll('.anchor a').forEach(f => {
  f.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector(e.target.getAttribute('href')).scrollIntoView({ behavior: "smooth" });
  });
});


// /////////////////////////////////////////////
// panzoom section
// /////////////////////////////////////////////

const panzoom = document.querySelector("#myPanzoom");

if (panzoom) {
  

  const myPanzoom = new Panzoom(panzoom, {
    maxScale: 4,
    Toolbar: {
        display: ["zoomIn", "zoomOut","reset"],
      },
    }, {
    Toolbar
  });

  let id2;
  let timerId;
  let position;
  let parentOffset;
  let width;
  let height


  document.addEventListener('click', function (e) {

    if (e.target.classList.contains('memberOnMap')){
      e.preventDefault();

      id2 = e.target.dataset.id;

      // const elem= document.getElementById('someid') // elem is an svg
      // const container = document.getElementById('demo-tiger')

      position = e.target.getBoundingClientRect();


      parentOffset = panzoom.getBoundingClientRect()

      const newPosition = {
        top: (position.top - parentOffset.top),
        left: (position.left - parentOffset.left)
      }

      // eslint-disable-next-line prefer-destructuring
      width = parentOffset.width;
      // eslint-disable-next-line prefer-destructuring
      height =parentOffset.height;

      // panZoom.value.panBy({ x: width / 2 - newPosition.left, y: height / 2 - newPosition.top })
      // panZoom.value.zoom(3)
  

      myPanzoom.panTo({

        scale: 1.3,
      });

      // myPanzoom.zoomTo(2, {  
      //   originX: document.querySelector(`#${id2}`).getAttribute('x'), 
      //   originY: document.querySelector(`#${id2}`).getAttribute('y'), 
      // });

      clearTimeout(timerId);

      if (document.querySelector('.pulse')){
        document.querySelector('.pulse').classList.remove('pulse');
      }
      

      document.querySelector(`#${id2}`).classList.add('pulse');


      // document.querySelector(`.f-panzoom`).scrollIntoView({ behavior: "smooth" });


      timerId = setTimeout(function () {
        document.querySelector(`#${id2}`).classList.remove('pulse');
      }, 8000);
    }

  });

}
// /////////////////////////////////////////////
// eof panzoom section
// /////////////////////////////////////////////

flatpickr(".pickMonth", {
  allowInput: true,
  enableTime: false,
  "locale": "ru",
  dateFormat: "Y-m",
  plugins: [
    new MonthSelectPlugin({
  //     shorthand: true, // defaults to false
      dateFormat: "Y-m", // defaults to "F Y"
  //     altFormat: "F Y", // defaults to "F Y"
    })
  ],

});


// const minDateMeet = '6.04.2023 00:00';

const minDateMeet = document.querySelector('.meetingTime') ? document.querySelector('.meetingTime').dataset.mindate : null;
const maxDateMeet = document.querySelector('.meetingTime') ? document.querySelector('.meetingTime').dataset.maxdate : null;

flatpickr(".meetingTime", {
  enableTime: true,
  "locale": "ru",
  dateFormat: "d.m.Y H:i",
  // minDate: '6.04.2023 00:00',
  // maxDate: "9.04.2023 23:45",
  minDate: minDateMeet,
  maxDate: maxDateMeet,
  time_24hr: "true",
  // locale: {
  //    firstDayOfWeek: 1
  // }
});

flatpickr(".datebth", {
  enableTime: false,
  "locale": "ru",
  dateFormat: "d.m.Y",
  // minDate: '6.04.2023 00:00',
  // maxDate: "9.04.2023 23:45",
  // locale: {
  //    firstDayOfWeek: 1
  // }
});